import { SwitchCase } from "@enkor/toss-slash";

import WebViewBridge from "@logics/utils/webViewBridge";
import { isIOSAndMac } from "@logics/utils/isMobile";
import {
  CtaType,
  ProjectInfoTrackingDataType,
} from "@domains/project/types/project";
import ProjectViewModel from "@domains/project/viewModel/ProjectViewModel";

import BaseButtonGroup from "./BaseButtonGroup/BaseButtonGroup";
import ParticipateButtonGroup from "./ParticipateButtonGroup/ParticipateButtonGroup";
import CancelButtonGroup from "./CancelButtonGroup/CancelButtonGroup";

import * as S from "./ProjectEventDetailButton.style";

interface ProjectDetailButtonProps {
  projectId: string;
  projectInfo: ProjectViewModel;
  ctaType: CtaType;
  isProjectClosed?: boolean;
}

const ProjectDetailButton = ({
  projectId,
  projectInfo,
  ctaType,
  isProjectClosed,
}: ProjectDetailButtonProps) => {
  const projectInfoData: ProjectInfoTrackingDataType = {
    projectId: projectInfo.id,
    projectTitle: projectInfo.title,
    projectFee: projectInfo.fee,
    projectDisplayFee: projectInfo.displayFee,
    projectMemberCount: projectInfo.memberCount,
    projectMaxMemberCount: projectInfo.maxMemberCount,
    ProjectImageUrlList: projectInfo.contentImageUrlList.map(({ url }) => url),
  };

  return (
    <S.BottomButtonBox
      $shouldFixSafeArea={!isIOSAndMac() || !WebViewBridge.isInAppWebView()}
    >
      <SwitchCase
        value={ctaType}
        defaultComponent={
          <BaseButtonGroup
            projectInfo={projectInfoData}
            actionButtonProps={{
              disabled: true,
            }}
          />
        }
        caseBy={{
          unjoined: (
            <ParticipateButtonGroup
              projectId={projectId}
              projectInfo={projectInfoData}
            />
          ),
          joined: (
            <CancelButtonGroup
              projectId={projectId}
              projectInfo={projectInfoData}
              isProjectClosed={isProjectClosed}
            />
          ),
          full: (
            <BaseButtonGroup
              projectInfo={projectInfoData}
              actionButtonProps={{
                disabled: true,
              }}
              buttonContent="Edition full"
            />
          ),
          closed: (
            <BaseButtonGroup
              projectInfo={projectInfoData}
              actionButtonProps={{
                disabled: true,
              }}
              buttonContent="Edition closed"
            />
          ),
        }}
      />
    </S.BottomButtonBox>
  );
};

export default ProjectDetailButton;
